import { linkStats } from './stats.js';
import { observeNewElements } from './elementsInViewport.js';

export const loadTeasers = async () => {
  const loadMoreButtons = document.querySelectorAll('.teaser_btn_more');
  if (!loadMoreButtons.length) return;

  loadMoreButtons.forEach((loadMoreButton) => {
    loadMoreButton.addEventListener('click', async () => {
      const previousElement = loadMoreButton.previousElementSibling;

      if (previousElement && previousElement.classList.contains('teaser')) {
        const dataLoadUrl = previousElement.getAttribute('data-more-url');

        if (dataLoadUrl) {
          try {
            const response = await fetch(dataLoadUrl);
            if (!response.ok) {
              throw new Error(`Server responded with status: ${response.status}`);
            }
            const html = await response.text();

            loadMoreButton.insertAdjacentHTML('beforebegin', html);

            // Tylko nowo doładowane zajawki w obrębie tej sekcji.
            const container = loadMoreButton.closest('.teasers');
            const newTeasers = Array.from(container.querySelectorAll('.teaser:not([data-initialized])'));
            newTeasers.forEach((teaser) => teaser.setAttribute('data-initialized', 'true'));
            linkStats(newTeasers);
            observeNewElements(newTeasers.filter((el) => el.classList.contains('_js_inViewport')));

            if (!newTeasers.some((teaser) => teaser.getAttribute('data-more-url'))) {
              loadMoreButton.style.display = 'none';
            }
          } catch (err) {
            console.log('Error', err);
            const errorMessage = document.createElement('div');
            errorMessage.classList.add('error-message');
            errorMessage.innerText = 'Wystąpił błąd podczas ładowania treści. Proszę spróbować ponownie.';
            loadMoreButton.insertAdjacentElement('beforebegin', errorMessage);

            setTimeout(() => {
              errorMessage.remove();
            }, 5000);
          }
        }
      }
    });
  });
};
